import React, { createContext, useContext } from 'react';

export type DragNDropContextProps = {
  isDragging: boolean;
  isDropping: boolean;
  setIsDragging: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDropping: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DragNDropContext = createContext<DragNDropContextProps>({
  isDragging: false,
  isDropping: false,
  setIsDragging: () => {
    // do nothing
  },
  setIsDropping: () => {
    // do nothing
  },
});

export const useDragNDropContext = () => useContext(DragNDropContext);
